<template>
    <section v-if="json" class="page-community">
        <SimpleFold :bgStyle="json.communityBackground?.[0].bgStyle" :title="json.panelTitle" :subtitle="json.subtitle"/>
        <SocialBlock></SocialBlock>
        <FanImages v-if="json.fanImages" :json="json"></FanImages>
        <TwoPanelCallouts v-if="json.twoPanelCallouts" :json="json.twoPanelCallouts"></TwoPanelCallouts>
        <TwitchBlock :json="json"></TwitchBlock>
        <NewsSnippetBlock :isHomePage="false" :json="json.newsBlock"></NewsSnippetBlock>
        <AllNews :json="json.allNews"></AllNews>
    </section>
</template>

<script>
import gsap from '@/plugins/gsap';
import ScrollToPlugin from "@/plugins/gsap/ScrollToPlugin";
import axios from 'axios'
import gh from '@/helpers/gh'
import TwoPanelCallouts from "@/components/blocks/TwoPanelCallouts";
import NewsSnippetBlock from "@/components/blocks/NewsSnippetBlock";
import TwitchBlock from "@/components/blocks/TwitchBlock";
import FanImages from "@/components/blocks/FanImages";
import AllNews from "@/components/blocks/AllNews";
import SimpleFold from "@/components/blocks/SimpleFold.vue";
import SocialBlock from "@/components/blocks/SocialBlock.vue";
gsap.registerPlugin(ScrollToPlugin);
export default {
    name: "CommunityPath",
    components: {
        SocialBlock,
        SimpleFold,
        NewsSnippetBlock,
        TwoPanelCallouts,
        TwitchBlock,
        FanImages,
        AllNews
    },
    data () {
        return {
            window: window,
            json: null,
            gh: gh,
        }
    },
    mounted () {
        let slug = this.$route.fullPath
        slug = gh.stripSlashesFrontAndBack(slug)
        const turl = gh.formatFeedUrl(slug)
        axios.get((turl))
            .then((res) => {
                this.json = res.data
                this.$nextTick(() => {
                    if (window.location.hash === "#all-blogs") {
                        // Pass a function reference to setTimeout so it runs after some ms
                        setTimeout(() => this.scrollTo("#all-blogs"), 250);
                    }
                });

            }).catch((e) => {
            console.error('Error', slug, e)
        })
    },
    beforeUnmount() {

    },
    methods: {
        scrollTo(selector) {
            gsap.to(window, { duration: 1, scrollTo: { y: selector, offsetY: 60 } });
        },
    }
}
</script>